import styles from './Footer.module.scss';

export default function Footer() {
  return (
    <div className={styles.footer}>
      <div className={styles.inner}>
        <ul className={styles.left}>
          <li>
            <a href="https://ggzecademy.nl/" target="_blank" rel="noreferrer">
              GGZ Ecademy - www.ggzecademy.nl
            </a>
          </li>
          <li>
            <a href="https://ggzecademy.nl/privacy/" target="_blank" rel="noreferrer">
              Privacyverklaring
            </a>
          </li>
        </ul>
        <ul className={styles.right}>
          <li>
            <a
              target="_blank"
              href="https://www.instagram.com/ggzecademy/"
              className="footer-social-link"
              rel="noreferrer"
            >
              <i className="fa-brands fa-square-instagram"></i>
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://www.linkedin.com/company/10646223/"
              className="footer-social-link"
              rel="noreferrer"
            >
              <i className="fa-brands fa-linkedin"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
